// extracted by mini-css-extract-plugin
module.exports = {"footer__nav":"Footer_footer__nav__KH_a7","footer__copyright":"Footer_footer__copyright___L_2p"};